<template>
  <div class="house-importer-kv-texts-panel">
    <app-panel title="Тексты квитанций">
      <div slot="actions">
        <app-button color="success" :disabled="isSaving" @click="saveTexts">{{ isSaving ? 'Сохраняю...' : 'Сохранить' }}
        </app-button>
      </div>

      <div>
        <div class="house-importer-kv-texts-panel__row">
          <div class="house-importer-kv-texts-panel__col house-importer-kv-texts-panel__col50">
            <elsa-quill-editor
              v-model="text1"
              :showAcceptButtons="false"
              class="house-importer-kv-texts-panel__editor"
            />
          </div>
          <div class="house-importer-kv-texts-panel__col house-importer-kv-texts-panel__col50">
            <elsa-quill-editor
              v-model="text2"
              :showAcceptButtons="false"
              class="house-importer-kv-texts-panel__editor"
            />
          </div>
        </div>
        <div class="house-importer-kv-texts-panel__row">
          <div class="house-importer-kv-texts-panel__col">
            <elsa-quill-editor
              v-model="text3"
              :showAcceptButtons="false"
              class="house-importer-kv-texts-panel__editor"
            />
          </div>
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
import ElsaQuillEditor from "@/components/ElsaQuillEditor";

export default {
  name:       "KvTextsPanel",
  components: {
    ElsaQuillEditor,
  },
  props:      {
    importInfo: {},
  },
  data() {
    return {
      isSaving: false,
      text1:    "",
      text2:    "",
      text3:    "",
    };
  },
  methods:    {
    async saveTexts() {
      this.isSaving = true;
      try {
        let body = {
          import_id: this.importInfo.id,
          text1:     this.text1,
          text2:     this.text2,
          text3:     this.text3,
        };
        await this.$http.post('import/houses/create_kv_texts', body);
        this.$vs.notify({ color: 'success', title: 'Успешное обновление', text: 'Тексты квитанций обновлены' });
      } catch (e) {
        this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
      } finally {
        setTimeout(() => {
          this.isSaving = false;
        }, 300);
      }
    },
    async getTexts() {
      try {
        let { data } = await this.$http.get('import/houses/kv_texts', { params: { import_id: this.importInfo.id } });
        this.text1 = data.text1 || "";
        this.text2 = data.text2 || "";
        this.text3 = data.text3 || "";
      } catch (e) {
        this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
      }
    },
  },
  created() {
    this.getTexts();
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'DejaVu Sans';
  src: url('~@/assets/fonts/DejavuSans/DejaVuSans.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'DejaVu Sans';
  src: url('~@/assets/fonts/DejavuSans/DejaVuSans-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

.house-importer-kv-texts-panel {

  &__row {
    display: flex;
    margin: 0 -7.5px;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &__col {
    flex: 1;
    padding: 0 7.5px;

    &50 {
      flex-basis: 50%;
      max-width: 50%;
    }
  }

  &__editor {
    height: 150px;
  }

  .ql-toolbar.ql-snow {
    padding: 8px 3px;
    height: 35px;
  }

  .quill-editor {
    height: calc(100% - 35px);
  }

  .ql-container .ql-editor {
    font-family: DejaVu Sans;
    letter-spacing: normal;
    color: #000;
    font-size: 11px;
    padding: 12px 15px;
    background: #fff;
    line-height: 1.5;
    padding: 10px !important;


    &.ql-blank::before {
      top: 10px;
      left: 10px;
      right: 10px;
    }

    p {
      margin: 0;
    }
  }
}

</style>
